exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.card-alert {\n  margin-top: 5px; }\n  .card-alert .item {\n    margin-top: 2.5px; }\n  .card-alert .link {\n    color: #53B7E8;\n    cursor: pointer; }\n  .card-alert .link:hover {\n    text-decoration: underline;\n    color: #585af6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/style/components/resources/credential-card-alert.scss
// module id = 1201
// module chunks = 49